import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { assignMetadata } from '../../utils/assign-metadata';
import { addLanguage, deleteLanguage, updateDefaultLanguage } from './actions';
import { LANGUAGES_SLICE_NAME } from './constants';
import type { Language, LanguagesState } from './types';

const additionalLanguagesAdapter = createEntityAdapter<Language>();
const additionalLanguagesSelectors = additionalLanguagesAdapter.getSelectors();

const initialState: LanguagesState = {
  defaultLanguageCode: '',
  updatedAt: '',
  updatedBy: '',
  additionalLanguages: additionalLanguagesAdapter.getInitialState(),
};

const slice = createSlice({
  name: LANGUAGES_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateDefaultLanguage, (state, action) => {
      state.defaultLanguageCode = action.payload.languageCode;
      assignMetadata(action, state);
    });

    builder.addCase(addLanguage, (state, action) => {
      const { code } = action.payload;
      const existingLanguage = additionalLanguagesSelectors.selectById(
        state.additionalLanguages,
        code,
      );

      if (existingLanguage) {
        return;
      }

      const language: Language = {
        id: code,
        code,
        createdAt: '',
        createdBy: '',
        updatedAt: '',
        updatedBy: '',
      };

      assignMetadata(action, language);
      additionalLanguagesAdapter.addOne(state.additionalLanguages, language);
    });

    builder.addCase(deleteLanguage, (state, action) => {
      additionalLanguagesAdapter.removeOne(
        state.additionalLanguages,
        action.payload.code,
      );
    });
  },
});

export { additionalLanguagesAdapter };

export { additionalLanguagesSelectors };

export default slice.reducer;
